import React, { PureComponent } from 'react'
import { FormControl, InputLabel, MenuItem, Select, Input } from '@material-ui/core'

import { isValidString } from '../../utils/string'

import ForwardRefHOC from '../../containers/HOC/ForwardRefHOC'
import ModalDialog from '../common/ModalDialog'

class AddLossReasonModal extends PureComponent {
  state = {
    description: '',
  }

  addLossReason = () => {
    const { description } = this.state

    if (!isValidString(description)) {
      this.props.onError('Please provide a valid loss reason description')
      return
    }

    this.props.addLossReason({ description, active: true })
  }

  onClose = () => {
    this.setState({
      description: '',
    })
  }

  onOpen = (type) => {
    this.setState({
      description: '',
    })
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  render() {
    const { forwardedRef } = this.props

    const { description } = this.state

    return (
      <ModalDialog
        title={'Add Loss Reason'}
        ref={forwardedRef}
        onConfirm={this.addLossReason}
        onClose={this.onClose}
        onOpen={this.onOpen}
      >
        <FormControl fullWidth className="margin-bottom-small">
          <InputLabel>Description *</InputLabel>
          <Input
            name="description"
            value={description}
            onChange={this.onChange}
            fullWidth
            inputProps={{
              maxLength: 50,
            }}
          />
        </FormControl>
      </ModalDialog>
    )
  }
}

export default ForwardRefHOC(AddLossReasonModal)



// WEBPACK FOOTER //
// ./src/components/Modal/AddLossReasonModal.js